module.exports = __webpack_public_path__ + "img/bandeau_kkbb3.910befb9.png";